import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";

// Page Imports
import Home from "@/pages/Home";
import Company from "@/pages/Company";
import Philosophy from "@/pages/Philosophy";
import FounderMessage from "@/pages/FounderMessage";
import Business from "@/pages/Business";
import Compliance from "@/pages/Compliance";
import MulticulturalApproach from "@/pages/MulticulturalApproach";
import Contact from "@/pages/Contact";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Layout>
          <Routes>
            {/* Standard (Japanese) Routes */}
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.COMPANY} element={<Company />} />
            <Route path={ROUTE_PATHS.PHILOSOPHY} element={<Philosophy />} />
            <Route path={ROUTE_PATHS.FOUNDER} element={<FounderMessage />} />
            <Route path={ROUTE_PATHS.BUSINESS} element={<Business />} />
            <Route path={ROUTE_PATHS.COMPLIANCE} element={<Compliance />} />
            <Route path={ROUTE_PATHS.MULTICULTURAL} element={<MulticulturalApproach />} />
            <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />

            {/* English (Global) Routes */}
            <Route path={ROUTE_PATHS.EN_HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.EN_COMPANY} element={<Company />} />
            <Route path={ROUTE_PATHS.EN_PHILOSOPHY} element={<Philosophy />} />
            <Route path={ROUTE_PATHS.EN_FOUNDER} element={<FounderMessage />} />
            <Route path={ROUTE_PATHS.EN_BUSINESS} element={<Business />} />
            <Route path={ROUTE_PATHS.EN_COMPLIANCE} element={<Compliance />} />
            <Route path={ROUTE_PATHS.EN_MULTICULTURAL} element={<MulticulturalApproach />} />
            <Route path={ROUTE_PATHS.EN_CONTACT} element={<Contact />} />

            {/* Fallback Catch-all */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;